export default __webpack_public_path__ + "static/media/mailhouseheader.39acf570.jpg";